export const SAVED_PROPERTY_VISUAL_TOKENS = [
  "pastel_sage_01",
  "pastel_sky_05",
  "pastel_blush_09",
  "pastel_butter_13",
  "pastel_lavender_07",
  "pastel_peach_11",
  "pastel_seafoam_03",
  "pastel_slate_19",
  "pastel_mint_02",
  "pastel_blue_06",
  "pastel_rose_10",
  "pastel_apricot_12",
  "pastel_aqua_04",
  "pastel_lilac_08",
  "pastel_honey_14",
  "pastel_clay_17",
  "pastel_moss_15",
  "pastel_fog_20",
  "pastel_terracotta_18",
  "pastel_olive_16",
] as const;

export type SavedPropertyVisualToken =
  (typeof SAVED_PROPERTY_VISUAL_TOKENS)[number];

type VisualTokenClasses = {
  accent: string;
  card: string;
  chip: string;
};

const VISUAL_TOKEN_CLASSES: Record<SavedPropertyVisualToken, VisualTokenClasses> = {
  pastel_sage_01: {
    accent: "bg-[#9b9369]",
    card: "border-[#cdc4a2] bg-[#eee8d5]",
    chip: "border-[#d7ceb0] bg-[#f7f1e2] text-[#453d24]",
  },
  pastel_mint_02: {
    accent: "bg-[#7d845e]",
    card: "border-[#bdc4a5] bg-[#e8ead8]",
    chip: "border-[#cbd1b7] bg-[#f2f3e7] text-[#333b25]",
  },
  pastel_seafoam_03: {
    accent: "bg-[#6f816a]",
    card: "border-[#b8c2ae] bg-[#e5ebde]",
    chip: "border-[#c8d0bf] bg-[#f0f4e9] text-[#283c2a]",
  },
  pastel_aqua_04: {
    accent: "bg-[#6c8175]",
    card: "border-[#b7c4ba] bg-[#e4ebe4]",
    chip: "border-[#c5d0c8] bg-[#eff4ef] text-[#263b33]",
  },
  pastel_sky_05: {
    accent: "bg-[#72806a]",
    card: "border-[#bbc4b0] bg-[#e7eadf]",
    chip: "border-[#c9d0bf] bg-[#f1f3ea] text-[#2d3827]",
  },
  pastel_blue_06: {
    accent: "bg-[#727765]",
    card: "border-[#c0c0aa] bg-[#e9e7d8]",
    chip: "border-[#ceccb8] bg-[#f3f1e6] text-[#333323]",
  },
  pastel_lavender_07: {
    accent: "bg-[#8c7a69]",
    card: "border-[#cabbaa] bg-[#eee4d8]",
    chip: "border-[#d5c8b9] bg-[#f7efe5] text-[#3f3027]",
  },
  pastel_lilac_08: {
    accent: "bg-[#8b7065]",
    card: "border-[#ccb5aa] bg-[#efe1d8]",
    chip: "border-[#d8c4bb] bg-[#f8ece4] text-[#432d25]",
  },
  pastel_blush_09: {
    accent: "bg-[#9a6f60]",
    card: "border-[#d0b4a7] bg-[#f0e0d6]",
    chip: "border-[#dbc4ba] bg-[#f8ece4] text-[#4a2d24]",
  },
  pastel_rose_10: {
    accent: "bg-[#9b675a]",
    card: "border-[#d2aea2] bg-[#f1ddd5]",
    chip: "border-[#ddc0b6] bg-[#f9ebe3] text-[#4d2a22]",
  },
  pastel_peach_11: {
    accent: "bg-[#a36f4f]",
    card: "border-[#d7b596] bg-[#f2dfcc]",
    chip: "border-[#e1c5aa] bg-[#faeddf] text-[#4d2d18]",
  },
  pastel_apricot_12: {
    accent: "bg-[#a47a4d]",
    card: "border-[#d8be98] bg-[#f1e5cf]",
    chip: "border-[#e1cbae] bg-[#f9f0e1] text-[#493114]",
  },
  pastel_butter_13: {
    accent: "bg-[#a08a56]",
    card: "border-[#d4c59d] bg-[#efe8d2]",
    chip: "border-[#ded0af] bg-[#f8f2e1] text-[#433616]",
  },
  pastel_honey_14: {
    accent: "bg-[#91884f]",
    card: "border-[#ccc396] bg-[#ece7cf]",
    chip: "border-[#d8d0ac] bg-[#f6f1df] text-[#3d3816]",
  },
  pastel_moss_15: {
    accent: "bg-[#817c5f]",
    card: "border-[#c5c0aa] bg-[#e9e6d8]",
    chip: "border-[#d1cbb9] bg-[#f3f1e7] text-[#363321]",
  },
  pastel_olive_16: {
    accent: "bg-[#746f57]",
    card: "border-[#beb8a4] bg-[#e6e2d4]",
    chip: "border-[#cbc5b4] bg-[#f1eee4] text-[#302d1f]",
  },
  pastel_clay_17: {
    accent: "bg-[#966a58]",
    card: "border-[#cfb3a5] bg-[#efded5]",
    chip: "border-[#dac3b8] bg-[#f8ece4] text-[#472c22]",
  },
  pastel_terracotta_18: {
    accent: "bg-[#9f7157]",
    card: "border-[#d4b7a2] bg-[#f1e0d2]",
    chip: "border-[#dec6b5] bg-[#faeee3] text-[#4a2f20]",
  },
  pastel_slate_19: {
    accent: "bg-[#807568]",
    card: "border-[#c4baad] bg-[#e9e3d8]",
    chip: "border-[#d1c7bb] bg-[#f3eee6] text-[#352d25]",
  },
  pastel_fog_20: {
    accent: "bg-[#797066]",
    card: "border-[#c1b8ae] bg-[#e8e2da]",
    chip: "border-[#cec6bd] bg-[#f2eee7] text-[#332d27]",
  },
};

export function getSavedPropertyVisualTokenClasses(
  token: string | null | undefined,
): VisualTokenClasses {
  if (
    token &&
    Object.hasOwn(VISUAL_TOKEN_CLASSES, token)
  ) {
    return VISUAL_TOKEN_CLASSES[token as SavedPropertyVisualToken];
  }
  return VISUAL_TOKEN_CLASSES[SAVED_PROPERTY_VISUAL_TOKENS[0]];
}
